module.exports = __webpack_public_path__ + "img/fa-comment.7fa70a36.svg";